<template>
  <div>
    <v-card flat width="400" class="custom-shadow">
      <v-card-text>
        <div>
          <h3 class="titleText--text">Region</h3>
          <v-select
            style="border-radius: 8px"
            dense
            color="titleText"
            hide-details="auto"
            placeholder="Select"
            solo
            flat
            class="mt-3"
            background-color="#F3F5F8"
            item-text="display"
            return-object
            v-model="selectedCountry"
            :items="countryitmes"
            label="Country"
            @change="getvalues()"
          ></v-select>
        </div>
        <div class="mt-3">
          <h3 class="titleText--text">Choose Period</h3>
          <v-row class="mt-3">
            <v-col cols="6" class="pt-0">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                 transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    style="border-radius: 8px"
                        dense
                        color="titleText"
                        hide-details="auto"
                        placeholder="From date"
                        solo
                        flat
                        background-color="#F3F5F8"
                        v-bind="attrs"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                  ><template v-slot:append>
                          <v-icon small color="rgb(80, 93, 111, .4)"
                            >mdi-calendar-blank-outline</v-icon
                          >
                        </template></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormattedto"
                    style="border-radius: 8px"
                        dense
                        color="titleText"
                        hide-details="auto"
                        placeholder="From date"
                        solo
                        flat
                        background-color="#F3F5F8"
                        v-bind="attrs"
                    @blur="dateto = parseDate(dateFormattedto)"
                    v-on="on"
                  > <template v-slot:append>
                          <v-icon small color="rgb(80, 93, 111, .4)"
                            >mdi-calendar-blank-outline</v-icon
                          >
                        </template></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateto"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </div>
        <div class="mt-3">
          <h3 class="titleText--text">
            Currency
          </h3>
          <div class="mt-1 d-flex align-center">
            <span class="mt-1" style="color: rgba(0, 0, 0, 1)">{{getCurrencyFlag(selectedcurrency)}}</span>
            <span class="ml-1 titleText--text">{{selectedcurrency}}</span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="mx-2 pt-0">
        <v-spacer />
        <v-btn
          color="blue"
          depressed
          height="32"
          width="120"
          dark
          :loading="isLoading"
          @click="getdataonclick()"
        >
          <span class="font-weight-bold text-capitalize"
            >Apply</span
          >
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import apifactory from "../api";
import apifactoryglobal from "../../../apis/apifactory"
import currencyFlag from '../../../constants/currencyFlag'

export default {
  name: "projectsetupctrl",
  components: {
    //  AppWidget,
  },
  data: () => ({
    drawer: false,
    countryitmes: [],
    selectedCountry: [], // [{ "country": "uk", "brand": "xyz", "level": "national", "display": "UK | XYZ | NATIONAL", "maxdate": "2021-08-01", "mindate": "2018-09-01" }],
    selectedCountryPre: null,
    selectedBrandPre: null,
    selectedlevelPre: null,
    selectedCurrencyPre: null,

    daterangedisplay: "",
    //for calander
    menu1: false,
    menu2: false,
    date: new Date().toISOString().substr(0, 10),
    dateto: new Date().toISOString().substr(0, 10),
    selectedfromdate: null,
    selectedtodate: null,
    //for currency
    listofcurrency: [],
    selectedcurrency: null,

    listofconvertcurrency: [],
    selectedconvertcurrency: null,

    Curryconvertermultiplicativefactor: 1,
    lstofaverageparm: null,
    isLoading: false
  }),
  methods: {
    getCurrencyFlag (currency) {
      return currencyFlag[currency]
    },
    getvalues() {
      this.daterangedisplay =
        "From:-" +
        this.selectedCountry.mindate +
        " To:- " +
        this.selectedCountry.maxdate;
      this.dateFormatted = this.formatDate(this.selectedCountry.mindate);
      this.dateFormattedto = this.formatDate(this.selectedCountry.maxdate);
      this.selectedcurrency = this.selectedCountry.currency_code;
      // alert(this.selectedCountry.currency_code);
    },
    getdataonclick() {
      let bresult = this.isvalidatepage();
      if (bresult) {
         this.saveprojectdetails();
      }
    },
    isvalidatepage() {
      let bresult = true;
      if (this.dateFormatted == null) {
        bresult = false;
      }
      if (this.dateFormattedto == null) {
        bresult = false;
      }
      if (this.selectedcurrency == null) {
        bresult = false;
      }
      /*if (this.selectedconvertcurrency == null) {
        bresult = false;
      }*/
      if (this.selectedCountry == null) {
        bresult = false;
      }
     // alert(bresult);
      return bresult;
    },
   
   
    openpopup() {
      this.getdataforprojectsetup();
      this.drawer = true;
      this.getProjectPrefillData();
    },
    getdataforprojectsetup() {
      apifactory
        .api_get_available_data()
        .then((res) => {
          this.countryitmes = res.data;
          //alert(JSON.stringify( this.countryitmes));
          let countrytemp = [];
          countrytemp = this.countryitmes.filter(
            (a) =>
              a.country == this.selectedCountryPre &&
              a.brand == this.selectedBrandPre &&
              a.level == this.selectedlevelPre
          );
          this.selectedCountry = countrytemp[0];
        })
        .catch(function (error) {
          alert("Error getdataforprojectsetup" + JSON.stringify(error));
          console.warn(error);
        });
    },
    
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseDatePreFilled(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    getProjectPrefillData() {
      //alert('hi');
      apifactory
        .api_get_project_stepOneData()
        .then((res) => {
          //alert(JSON.stringify(res.data));
         
          if (res.status === false) {
            this.selectedCountryPre = res.data.country;
         
          } else {
         
            this.selectedCountryPre = res.data.country;
            this.selectedBrandPre = res.data.brand;
            this.selectedlevelPre = res.data.level;
            this.dateFormatted = this.parseDatePreFilled(res.data.start_date);
            this.dateFormattedto = this.parseDatePreFilled(res.data.end_date);
            this.selectedCurrencyPre = res.data.currency;
            this.selectedcurrency=this.selectedCurrencyPre;
           
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
     saveprojectdetails() {
      this.isLoading = true
      apifactory
        .api_save_project_details(
          this.selectedCountry.country,
          this.selectedCountry.brand,
          this.selectedCountry.level,
          this.parseDate(this.dateFormatted),
          this.parseDate(this.dateFormattedto),
          this.selectedcurrency
        )
        .then(() => {
            this.saveprojectdetails_get_save_step1();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
     saveprojectdetails_get_save_step1() {
      apifactory
        .get_save_step1()
        .then(() => {
          this.CheckNextStepParms();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    CheckNextStepParms() {
      apifactory
        .gettheParameterByProjectStepSummary()
        .then((res) => {
          //alert("CheckNextStepParms:-" + JSON.stringify(res));
          if (res.status != 200) {
            //alert("error:-" + JSON.stringify(res.data));
             console.warn(res);
          
          }
           this.saveAndSetStepParmsNew();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
     saveAndSetStepParmsNew() {
      if (this.lstofaverageparm == null) {
        this.lstofaverageparm = "''";
      }
      let url_querystring = "average=" + this.lstofaverageparm;

      apifactory
        .addParameterBySteps("2", url_querystring)
        .then((res) => {
          console.warn(res);
            //alert("saveAndSetStepParmsNew:-" + JSON.stringify(res));
           this.call_save_step3_paramaters();
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },
    call_save_step3_paramaters() {
      //alert("call call_save_step3_paramaters");
      apifactoryglobal
        .api_save_project_details_step3()
        .then((res) => {
           console.warn(res);
            //alert("call_save_step3_paramaters:-" + JSON.stringify(res));
           this.call_save_step3();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    // save all steps
    call_save_step3() {
      apifactoryglobal
        .api_save_step3()
        .then((res) => {
           console.warn(res);
             //("call_save_step3:-" + JSON.stringify(res));
           this.call_save_step4();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    call_save_step4() {
      apifactoryglobal
        .api_save_step4()
        .then((res) => {
           console.warn(res);
              //alert("call_save_step4:-" + JSON.stringify(res));
           this.call_save_step5();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    call_save_step5() {
      apifactoryglobal
        .api_save_step4()
        .then(() => {
            this.isLoading = false
            window.location.reload()
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
  mounted() {
    this.openpopup();

  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },

    computedDateFormattedto() {
      return this.formatDate(this.dateto);
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    dateto() {
      this.dateFormattedto = this.formatDate(this.dateto);
    },
  },
};
</script>
<style scoped>
.selectedvaluelabel {
  font-weight: bold !important;
}
</style>
